var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dropdown",staticClass:"m-dropdown",on:{"click":_vm.handleClick}},[_vm._t("default"),_c('transition',{attrs:{"name":"m-dropdown"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"m-dropdown-panel",class:{
        'is-center': _vm.align === 'center',
        'is-right': _vm.align === 'right',
        'is-left': _vm.align === 'left'
      },style:(Object.assign({}, {margin: _vm.margin},
        _vm.panelStyle))},[_vm._t("panel")],2)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }